// src/app/core/ui-redirect.initializer.ts
import { UserService } from './_services/user.service';
import { of } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { redirectToRightApp } from './ui-redirect';

function parseBool(v: any): boolean {
  if (typeof v === 'boolean') return v;
  if (typeof v === 'string') return v.toLowerCase() === 'true';
  return !!v;
}

export function initUiRedirectFactory(userService: UserService) {
  return async () => {
    try {
      const data: any = await userService
        .getLoginFlag()
        .pipe(
          timeout(8000),
          catchError(() => of(null))
        )
        .toPromise();   // ✅ RxJS 6 way

      const flags = data?.configFlags ?? [];
      const isNewUIRedirect = flags.find((f: any) => f?.name === 'isNewUi')?.value;
      const isNewUI = parseBool(isNewUIRedirect);

      localStorage.setItem('isNewUI', String(isNewUI));
      redirectToRightApp(isNewUI);
    } catch {
      const cached = localStorage.getItem('isNewUI');
      const fallback = cached ? cached === 'true' : false;
      redirectToRightApp(fallback);
    }
  };
}
